<template>
  <v-row>
    <v-col cols="12">
      <b-input
        v-model="auditDTO.name"
        :error-messages="getErrorMessages(v$.name)"
        hide-details
        label="Назва аудиту"
        placeholder="введіть назву аудиту"
        @blur="v$.name.$touch()"></b-input>
    </v-col>

    <v-col cols="12" md="6">
      <b-label label="Вид"></b-label>
      <v-chip color="grey-darken-3" density="compact" rounded="pill">
        <span class="font-weight-bold text-grey-darken-2"
          >{{ audit.type.name }} ({{ audit.year }})
        </span>
      </v-chip>
    </v-col>
    <v-col cols="12" md="6">
      <b-label label="Повʼязаний план аудиту"></b-label>
      <div class="object-block d-flex align-center">
        <div v-if="audit.planId">
          <router-link
            :to="{ name: 'plan-single', params: { id: audit.planId } }"
            class="link font-size-15">
            {{ audit.plan?.name }}
          </router-link>
        </div>
        <span v-else class="text-disabled">Відсутній</span>
      </div>
    </v-col>

    <v-col cols="12" md="6">
      <b-select
        v-model="auditDTO.objectTypeId"
        :items="$directory.get('auditObjectTypes', audit.objectType)"
        :loading="$loading.isLoading('auditObjectTypes')"
        hide-details
        label="Обʼєкт аудиту"
        @focus="$directory.fill('auditObjectTypes')"></b-select>
    </v-col>
    <v-col cols="12" md="6">
      <object-departments></object-departments>
    </v-col>

    <v-col class="12" md="6">
      <b-input-date
        v-model:end-date="auditDTO.endAuditDate"
        v-model:start-date="auditDTO.startAuditDate"
        hide-details
        label="Період, що перевіряється"
        range></b-input-date>
    </v-col>
    <v-col class="12" md="6"></v-col>

    <v-col class="12" md="6">
      <b-input-date
        v-model="auditDTO.startScheduledCheckDate"
        :error-messages="getErrorMessages(v$.startScheduledCheckDate)"
        hide-details
        label="Дата початку аудиту"
        @blur="v$.startScheduledCheckDate.$touch()"></b-input-date>
    </v-col>
    <v-col class="12" md="6">
      <b-input-date
        v-model="auditDTO.endScheduledCheckDate"
        :error-messages="getErrorMessages(v$.endScheduledCheckDate)"
        hide-details
        label="Дата завершення аудиту"
        @blur="v$.endScheduledCheckDate.$touch()"></b-input-date>
    </v-col>

    <v-col cols="12">
      <b-textarea
        v-model="auditDTO.description"
        hide-details
        label="Короткий опис"
        placeholder="введіть короткий опис"
        rows="3"></b-textarea>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { BInputDate, BLabel, BTextarea } from 'best-modules/components'
import { useAudit } from '../../index'
import { getErrorMessages } from 'best-modules/utils'
import ObjectDepartments from './ObjectDepartments.vue'

export default {
  name: 'GeneralInfo',
  components: { ObjectDepartments, BLabel, BInputDate, BTextarea },
  methods: { getErrorMessages },
  setup() {
    return { ...useAudit() }
  },
}
</script>

<style lang="scss" scoped>
.object-block {
  padding: 3px 13px;
  background: #f5f6fa;
  border-radius: 9px;
  border: 1px solid #f0f0f5;
  color: #1a1a1b;
  min-height: 40px;
  max-height: 40px;

  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
